export const CONDITION_CHANGE = 'change:condition';
